module.exports = __webpack_public_path__ + "img/email_step1.fd9c9ec5.png";